import store from '@/store/store'
import ApiService from '@/services/ApiService'

let api = new ApiService()

export default {
    checkVersion () {
        store.dispatch('checkVersion')
    },
    GetLicenseDetails () {
        return {
            baseUrl: api.baseUrl,
            version: store.getters.version
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/LicenseService.js